import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../../Global/OrderColumn/index";
import EmptyData from "../../../Global/EmptyData";
import usePlanList from "./usePlanList";
import AddSubscriptionPlan from "./AddSubscriptionPlan";

const PlanList = ({ groupProductId, title = "Subscription Plans" }) => {
  const {
    isLoading,
    isFetching,
    planList,
    planState,
    showEditModal,
    paginationOptions,
    handleEditColumnsClick,
    updateSubscriptionPlanFields,
    handleDeleteModal,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleDelete,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = usePlanList(groupProductId);

  return (
    <div>
      <HeadingGroup
        title={title}
        className={`pro-mb-4`}
        // Sizes are added to a tile from the plan form, by ticking another size on any of them
        // - so there is nothing to create from inside one.
        buttonTitle={!groupProductId && planList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={planState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: planState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {planList?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={planList?.result || []}
            uniqueID={"id"}
            fields={planList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={planState?.clearSelection}
            loading={isFetching}
            perpage={planState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={planList?.delete_permission}
            editable={planList?.edit_permission}
            showCheckBox={
              planList?.delete_permission || planList?.edit_permission
            }
          />
        )}

        {planList?.result?.length > 0 && (
          <Pagination
            currentPage={planState?.currentPage}
            totalPageCount={Math.ceil(
              planList?.total_count / planState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === planState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout
          show={planState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected Plan ?"}
              subTitle={
                "Subscriptions already sold keep their own frozen copy and are unaffected."
              }
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={planList?.fields || []}
              moduleId={planList?.module_id}
              updateData={updateSubscriptionPlanFields}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={planState?.showCreateModal}
          handleClose={handleCreateClick}
          title={
            planState?.isEdit ? "Update Subscription Plan" : "Add Subscription Plan"
          }
          backdrop={"static"}
        >
          <AddSubscriptionPlan
            handleCreateClick={handleCreateClick}
            refetch={refetch}
            isStickyFooter
          />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default PlanList;
